import type { AiOptions } from '@mtm/conversation-client-sdk-annotation';
import { Subject, takeUntil } from 'rxjs';
import { BaseClassHandler } from '../base-class-handler/base-class-handler';
import {
  onAnnotationsStateChanged,
  onDeleteAnnotation,
  onDeleteCommentAnnotation,
} from '../../services/annotation.service';

export class PlatformCommentHandler implements BaseClassHandler {
  annotationPlugin: any;
  instanceId: string;
  item: any;
  handlerReady: boolean = false;
  ngUnsubscribe = new Subject();

  constructor(annotationPlugin: any, item: any, instanceId: string) {
    window['platformCommentHandler'] = this;
    this.annotationPlugin = annotationPlugin;
    this.item = item;
    this.instanceId = instanceId;
    this.setup();

    onDeleteAnnotation.pipe(takeUntil(this.ngUnsubscribe)).subscribe({
      next: (args: any) => this.onDeleteAnnotation(args),
    });

    onDeleteCommentAnnotation.pipe(takeUntil(this.ngUnsubscribe)).subscribe({
      next: (args: any) => this.deleteCommentAnnotation(args),
    });
  }

  setup() {
    this.registerListeners();
    this.handlerReady = true;
  }

  registerListeners() {
    this.annotationPlugin.registerListener('onStateChanged', (event: any) => {
      onAnnotationsStateChanged.emit({});
    });
  }

  saveAnnotation(annotationComment: string, aiParams: AiOptions) {
    const annotationParams = {
      annotationComment: annotationComment,
      agentVersionId: aiParams.agentVersionId ?? null,
      mediaQuality: aiParams.mediaQuality ?? null,
    };
    this.annotationPlugin.fire('saveNewAnnotation', { annotationParams });
  }

  saveEditedAnnotation(annotationComment: string, aiParams: AiOptions) {
    const annotationParams = {
      annotationComment: annotationComment,
      agentVersionId: aiParams.agentVersionId ?? null,
      mediaQuality: aiParams.mediaQuality ?? null,
    };
    this.annotationPlugin.fire('saveEditedAnnotation', { annotationParams });
  }

  replyToComment(annotationId: string, commentBody: string, agentVersionId: string, files?: any[]) {
    this.annotationPlugin.fire('newComment', {
      annotationId: annotationId,
      body: commentBody,
      agentVersionId: agentVersionId,
    });
  }

  deleteCommentAnnotation(args: any) {
    if (args.instanceId != this.instanceId || args.itemId != this.item.id) {
      return;
    }
    this.annotationPlugin.fire('destroyComment', { id: args.comment.id, annotation: args.annotation });
  }

  onDeleteAnnotation(args: any) {
    if (args.itemId != this.item.id) {
      return;
    }
    if (args.annotation && this.annotationPlugin) {
      this.annotationPlugin.fire('destroyAnnotation', { id: args.annotation.id });
    }
  }

  teardown() {
    this.annotationPlugin.fire('dispose');
    this.ngUnsubscribe.next(undefined);
    this.ngUnsubscribe.complete();
  }
}
